module.exports = __webpack_public_path__ + "static/media/esclated-icon.f67b5db8.svg";